/**
 * @copyright NIIT Technologies Ltd. 2017-18.
 */
// Angular
import { 
    NgModule, NgZone, Component, ElementRef, Renderer, Input, Output, 
    forwardRef, EventEmitter, SimpleChanges 
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { NG_VALUE_ACCESSOR, ControlValueAccessor, FormsModule, ReactiveFormsModule } from '@angular/forms';
// Core
import { ControlComponent } from '../../core/component/control.component';

// Control Value Accessor
const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => NgcLinkComponent),
    multi: true
};

/**
 * Icon Link
 */
@Component({
    selector: 'ngc-link',
    template: `
            <a *ngIf="visible" [ngClass]="linkClass" href="javascript:void(0)" (click)="onClick($event)">
                <i [ngClass]="iconClass" [style.color]="_displayColor" aria-hidden="true"></i>
                {{ title }}
            </a>
            `,
    providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR]
})
export class NgcLinkComponent extends ControlComponent {
    private _displayColor:string = "black";
    private _color:string = "black";
    //
    @Input("title") public title:string = "";
    @Input("iconClass") public iconClass:string = "";
    @Input("linkClass") public linkClass:string = "small";

    //
    @Output("linkClick") private clickEmitter: EventEmitter<any>;
    
    /**
     * Initialize
     */
    constructor(private ngZone: NgZone, private elementRef: ElementRef, private rendererRef: Renderer) {
        super(ngZone, elementRef, rendererRef);
    }

    /**
     * Sets Color
     */
    @Input("color")
    public set color(color: string) {
        if (!this.disabled && this._color !== color) {
            this._color = color;
            this.modelUpdated(this._color);
        } else if(this.disabled) {
            this._color = color;
            this.disabledUpdateCallback();
        }
    }

    /**
     * Gets Color
     */
    public get color(): string {
        return this._color;
    }

    /**
     * Calls on Disabled State Update
     */
    public disabledUpdateCallback(): void {
        if (this.disabled) {
            this._displayColor = "grey";
        }
    }

    /**
     * On Click
     * 
     * @param event Event
     */
    public onClick(event) {
        if (this.value && this.clickEmitter && !this.disabled) {
            this.clickEmitter.emit(this.value);
        }
    }

}

/**
 * Link Module
 */
@NgModule({
    imports: [CommonModule],
    exports: [NgcLinkComponent],
    declarations: [NgcLinkComponent]
})
export class NgcLinkModule {
}